/* eslint-disable @typescript-eslint/no-explicit-any */
import * as XLSXModule from 'xlsx-js-style'

export const XLSX = (XLSXModule as any).default || XLSXModule

// =============================================================================
// PALETA DE CORES CORPORATIVA GID
// =============================================================================
export const CORPORATE_COLORS = {
  headerBg: '0F172A',      // Slate 900 (Dark Slate GID)
  headerSubBg: '1E293B',   // Slate 800 (Navy Slate)
  metaBg: '334155',        // Slate 700
  corteBg: 'F1F5F9',       // Slate 100
  limeGid: 'A6C10B',       // Verde Neon Corporativo GID
  textDark: '0F172A',      // Texto escuro
  textMuted: '64748B',     // Texto secundário
  textWhite: 'FFFFFF',     // Branco
  borderSubtle: 'E2E8F0',  // Borda suave de células
  borderHeader: '475569',  // Borda entre colunas do cabeçalho
  zebraBg: 'F8FAFC',       // Fundo alternado linhas pares
  totalBg: 'E2E8F0',       // Fundo linha de total
  totalBorder: '0F172A',   // Borda dupla contábil totalizadores
}

export const getRowBorder = () => ({
  top: { style: 'thin', color: { rgb: CORPORATE_COLORS.borderSubtle } },
  bottom: { style: 'thin', color: { rgb: CORPORATE_COLORS.borderSubtle } },
  left: { style: 'thin', color: { rgb: CORPORATE_COLORS.borderSubtle } },
  right: { style: 'thin', color: { rgb: CORPORATE_COLORS.borderSubtle } },
})

export const getTotalBorder = () => ({
  top: { style: 'thin', color: { rgb: '64748B' } },
  bottom: { style: 'double', color: { rgb: CORPORATE_COLORS.totalBorder } },
  left: { style: 'thin', color: { rgb: CORPORATE_COLORS.borderSubtle } },
  right: { style: 'thin', color: { rgb: CORPORATE_COLORS.borderSubtle } },
})

// Células de Cabeçalho Institucional
export const cellBannerTitle = (val: string) => ({
  v: val,
  t: 's' as const,
  s: {
    font: { name: 'Calibri', sz: 13, bold: true, color: { rgb: CORPORATE_COLORS.textWhite } },
    fill: { fgColor: { rgb: CORPORATE_COLORS.headerBg } },
    alignment: { horizontal: 'center', vertical: 'center' },
  },
})

export const cellBannerSubtitle = (val: string) => ({
  v: val,
  t: 's' as const,
  s: {
    font: { name: 'Calibri', sz: 11, bold: true, color: { rgb: CORPORATE_COLORS.limeGid } },
    fill: { fgColor: { rgb: CORPORATE_COLORS.headerSubBg } },
    alignment: { horizontal: 'center', vertical: 'center' },
  },
})

export const cellBannerMeta = (val: string) => ({
  v: val,
  t: 's' as const,
  s: {
    font: { name: 'Calibri', sz: 9.5, color: { rgb: 'F1F5F9' } },
    fill: { fgColor: { rgb: CORPORATE_COLORS.metaBg } },
    alignment: { horizontal: 'center', vertical: 'center' },
  },
})

export const cellColHeader = (val: string, align: 'left' | 'center' | 'right' = 'center') => ({
  v: val,
  t: 's' as const,
  s: {
    font: { name: 'Calibri', sz: 10, bold: true, color: { rgb: CORPORATE_COLORS.textWhite } },
    fill: { fgColor: { rgb: CORPORATE_COLORS.headerSubBg } },
    alignment: { horizontal: align, vertical: 'center', wrapText: true },
    border: {
      top: { style: 'thin', color: { rgb: '64748B' } },
      bottom: { style: 'medium', color: { rgb: CORPORATE_COLORS.limeGid } },
      left: { style: 'thin', color: { rgb: CORPORATE_COLORS.borderHeader } },
      right: { style: 'thin', color: { rgb: CORPORATE_COLORS.borderHeader } },
    },
  },
})

// Célula de Texto Geral
export const cellText = (
  val: any,
  isEvenOrOptions:
    | boolean
    | { center?: boolean; align?: 'left' | 'center' | 'right'; isEven?: boolean; bold?: boolean } = false,
  alignParam: 'left' | 'center' | 'right' = 'left',
  boldParam = false
) => {
  let isEven = false
  let align = alignParam
  let bold = boldParam

  if (typeof isEvenOrOptions === 'boolean') {
    isEven = isEvenOrOptions
  } else if (isEvenOrOptions && typeof isEvenOrOptions === 'object') {
    if (isEvenOrOptions.center) align = 'center'
    if (isEvenOrOptions.align) align = isEvenOrOptions.align
    if (isEvenOrOptions.isEven) isEven = isEvenOrOptions.isEven
    if (isEvenOrOptions.bold) bold = isEvenOrOptions.bold
  }

  return {
    v: val !== null && val !== undefined ? String(val) : '',
    t: 's' as const,
    s: {
      font: { name: 'Calibri', sz: 9.5, bold, color: { rgb: CORPORATE_COLORS.textDark } },
      fill: { fgColor: { rgb: isEven ? CORPORATE_COLORS.zebraBg : 'FFFFFF' } },
      alignment: { horizontal: align, vertical: 'center' },
      border: getRowBorder(),
    },
  }
}

// Célula de Moeda
export const cellMoney = (val: number, isEven = false, bold = false) => ({
  v: Number((val || 0).toFixed(2)),
  t: 'n' as const,
  z: '"R$" #,##0.00',
  s: {
    font: { name: 'Calibri', sz: 9.5, bold, color: { rgb: CORPORATE_COLORS.textDark } },
    fill: { fgColor: { rgb: isEven ? CORPORATE_COLORS.zebraBg : 'FFFFFF' } },
    alignment: { horizontal: 'right', vertical: 'center' },
    border: getRowBorder(),
  },
})

// Célula de Número Inteiro ou com Formato
export const cellNumber = (
  val: number,
  isEvenOrFormat: boolean | string = false,
  bold = false
) => {
  let isEven = false
  let format = '#,##0'
  if (typeof isEvenOrFormat === 'boolean') {
    isEven = isEvenOrFormat
  } else if (typeof isEvenOrFormat === 'string') {
    format = isEvenOrFormat
  }

  return {
    v: format.includes('.') ? Number((val || 0).toFixed(2)) : Math.round(val || 0),
    t: 'n' as const,
    z: format,
    s: {
      font: { name: 'Calibri', sz: 9.5, bold, color: { rgb: CORPORATE_COLORS.textDark } },
      fill: { fgColor: { rgb: isEven ? CORPORATE_COLORS.zebraBg : 'FFFFFF' } },
      alignment: { horizontal: 'right', vertical: 'center' },
      border: getRowBorder(),
    },
  }
}

// Célula Percentual
export const cellPercent = (
  val: number,
  isEvenOrFormat: boolean | string = false,
  bold = false
) => {
  let isEven = false
  let format = '0.0%'
  if (typeof isEvenOrFormat === 'boolean') {
    isEven = isEvenOrFormat
  } else if (typeof isEvenOrFormat === 'string') {
    format = isEvenOrFormat
  }

  const numVal = Math.abs(val) > 1 ? val / 100 : val

  return {
    v: Number((numVal || 0).toFixed(4)),
    t: 'n' as const,
    z: format,
    s: {
      font: { name: 'Calibri', sz: 9.5, bold, color: { rgb: CORPORATE_COLORS.textDark } },
      fill: { fgColor: { rgb: isEven ? CORPORATE_COLORS.zebraBg : 'FFFFFF' } },
      alignment: { horizontal: 'right', vertical: 'center' },
      border: getRowBorder(),
    },
  }
}

// Células de Totalizadores
export const cellTotalLabel = (val: string, align: 'left' | 'center' | 'right' = 'center') => ({
  v: val,
  t: 's' as const,
  s: {
    font: { name: 'Calibri', sz: 10, bold: true, color: { rgb: CORPORATE_COLORS.headerBg } },
    fill: { fgColor: { rgb: CORPORATE_COLORS.totalBg } },
    alignment: { horizontal: align, vertical: 'center' },
    border: getTotalBorder(),
  },
})

export const cellTotalMoney = (val: number) => ({
  v: Number((val || 0).toFixed(2)),
  t: 'n' as const,
  z: '"R$" #,##0.00',
  s: {
    font: { name: 'Calibri', sz: 10, bold: true, color: { rgb: CORPORATE_COLORS.headerBg } },
    fill: { fgColor: { rgb: CORPORATE_COLORS.totalBg } },
    alignment: { horizontal: 'right', vertical: 'center' },
    border: getTotalBorder(),
  },
})

export const cellTotalNumber = (val: number, customFormat = '#,##0') => ({
  v: customFormat.includes('.') ? Number((val || 0).toFixed(2)) : Math.round(val || 0),
  t: 'n' as const,
  z: customFormat,
  s: {
    font: { name: 'Calibri', sz: 10, bold: true, color: { rgb: CORPORATE_COLORS.headerBg } },
    fill: { fgColor: { rgb: CORPORATE_COLORS.totalBg } },
    alignment: { horizontal: 'right', vertical: 'center' },
    border: getTotalBorder(),
  },
})

export const cellTotalPercent = (val: number, customFormat = '0.0%') => {
  const numVal = Math.abs(val) > 1 ? val / 100 : val
  return {
    v: Number((numVal || 0).toFixed(4)),
    t: 'n' as const,
    z: customFormat,
    s: {
      font: { name: 'Calibri', sz: 10, bold: true, color: { rgb: CORPORATE_COLORS.headerBg } },
      fill: { fgColor: { rgb: CORPORATE_COLORS.totalBg } },
      alignment: { horizontal: 'right', vertical: 'center' },
      border: getTotalBorder(),
    },
  }
}

/**
 * Calcula auto-ajuste de colunas
 */
export const autoFitColumns = (dataRows: any[][], minWidth = 12) => {
  if (!dataRows || dataRows.length === 0) return []

  const colWidths: number[] = []

  dataRows.forEach((row, rowIndex) => {
    if (rowIndex < 4 || row.length <= 1) return

    row.forEach((cell, colIndex) => {
      let cellStr = ''
      if (cell !== null && cell !== undefined) {
        if (typeof cell === 'object' && 'v' in cell) {
          if (typeof cell.v === 'number') {
            cellStr = cell.v.toLocaleString('pt-BR')
            if (cell.z && cell.z.includes('R$')) cellStr = `R$ ${cellStr}`
            if (cell.z && cell.z.includes('%')) cellStr = `${cellStr}%`
          } else {
            cellStr = String(cell.v)
          }
        } else {
          cellStr = String(cell)
        }
      }
      const len = Math.max(cellStr.length + 3, minWidth)
      if (!colWidths[colIndex] || len > colWidths[colIndex]) {
        colWidths[colIndex] = Math.min(len, 60)
      }
    })
  })

  return colWidths.map((wch) => ({ wch: wch || minWidth }))
}

export interface CorporateHeaderConfig {
  label: string
  key?: string
  align?: 'left' | 'center' | 'right'
}

export interface BuildCorporateSheetParams {
  reportTitle?: string
  title?: string
  subtitle?: string
  meta?: string
  periodLabel?: string
  distributorLabel?: string
  headers: Array<string | CorporateHeaderConfig>
  data?: any[][] | any[]
  dataRows?: any[][] | any[]
  totalsRow?: any[]
}

/**
 * Cria uma planilha estilizada completa a partir de cabeçalhos e linhas
 */
export const buildCorporateSheet = (params: BuildCorporateSheetParams) => {
  const {
    reportTitle,
    title,
    subtitle,
    meta,
    periodLabel,
    distributorLabel,
    headers,
    data,
    dataRows,
    totalsRow,
  } = params

  const effectiveTitle = title || 'GID — SISTEMA DE GESTÃO DE INFORMAÇÕES DE DISTRIBUIDORES'
  const effectiveSubtitle =
    subtitle || (reportTitle ? `RELATÓRIO: ${reportTitle.toUpperCase()}` : 'RELATÓRIO EXECUTIVO CORPORATIVO')
  const dataExtracao = new Date().toLocaleString('pt-BR')
  const periodStr = periodLabel || 'Período Completo'
  const distStr = distributorLabel || 'Todos os Distribuidores'
  const effectiveMeta =
    meta || `Período: ${periodStr}   |   Distribuidor: ${distStr}   |   Extraído em: ${dataExtracao}`

  const normHeaders: CorporateHeaderConfig[] = headers.map((h) =>
    typeof h === 'string' ? { label: h, align: 'center' } : h
  )

  const lastColIdx = Math.max(normHeaders.length - 1, 3)

  const sheetData: any[][] = [
    [cellBannerTitle(effectiveTitle)],
    [cellBannerSubtitle(effectiveSubtitle)],
    [cellBannerMeta(effectiveMeta)],
    [],
    normHeaders.map((h) => cellColHeader(h.label, h.align || 'center')),
  ]

  // Detectar formato com base no valor ou nome da coluna
  const isCurrencyCol = (colName: string) => {
    const n = colName.toLowerCase()
    return (
      n.includes('valor') ||
      n.includes('r$') ||
      n.includes('preço') ||
      n.includes('preco') ||
      n.includes('faturamento') ||
      n.includes('receita')
    )
  }

  const isNumericCol = (colName: string) => {
    const n = colName.toLowerCase()
    return (
      n.includes('cx') ||
      n.includes('caixa') ||
      n.includes('unidade') ||
      n.includes('qnt') ||
      n.includes('qtd') ||
      n.includes('quantidade') ||
      n.includes('cobertura') ||
      n.includes('pdv') ||
      n.includes('estoque') ||
      n.includes('cadastrada') ||
      n.includes('ativos') ||
      n.includes('perdidos') ||
      n.includes('justificados') ||
      n.includes('pendentes')
    )
  }

  const isPercentCol = (colName: string) => {
    const n = colName.toLowerCase()
    return n.includes('%') || n.includes('share') || n.includes('taxa')
  }

  const isCenterCol = (colName: string) => {
    const n = colName.toLowerCase()
    return (
      n.includes('data') ||
      n.includes('dt_') ||
      n.includes('cnpj') ||
      n.includes('cpf') ||
      n.includes('uf') ||
      n.includes('cod') ||
      n.includes('pos') ||
      n.includes('tipo') ||
      n.includes('status')
    )
  }

  const rows = (dataRows || data || []) as any[]

  // Preenchimento de linhas
  rows.forEach((row, rowIdx) => {
    const isEven = rowIdx % 2 === 1
    const rowCells: any[] = []

    normHeaders.forEach((h, colIdx) => {
      let val: any
      if (Array.isArray(row)) {
        val = row[colIdx]
      } else if (h.key) {
        val = row[h.key]
      } else {
        val = row[colIdx]
      }

      // Se a célula já for um objeto formatado (com estilo do SheetJS/xlsx-js-style)
      if (val !== null && typeof val === 'object' && ('s' in val || 't' in val || 'v' in val)) {
        rowCells.push(val)
        return
      }

      const colName = h.label || ''

      if (val === null || val === undefined) {
        rowCells.push(cellText('', isEven, 'center'))
        return
      }

      // Se já for número
      if (typeof val === 'number') {
        if (isCurrencyCol(colName)) {
          rowCells.push(cellMoney(val, isEven))
        } else if (isPercentCol(colName)) {
          rowCells.push(cellPercent(val, isEven))
        } else if (isNumericCol(colName)) {
          rowCells.push(cellNumber(val, isEven))
        } else {
          rowCells.push(cellText(val, isEven, h.align || 'right'))
        }
      } else {
        // String ou data
        const align = h.align || (isCenterCol(colName) ? 'center' : 'left')
        rowCells.push(cellText(val, isEven, align))
      }
    })

    sheetData.push(rowCells)
  })

  // Linha de total se existir
  if (totalsRow && totalsRow.length > 0) {
    const totalCells: any[] = []
    normHeaders.forEach((h, colIdx) => {
      const val = totalsRow[colIdx]

      // Se a célula já for um objeto formatado
      if (val !== null && typeof val === 'object' && ('s' in val || 't' in val || 'v' in val)) {
        totalCells.push(val)
        return
      }

      const colName = h.label || ''

      if (val === null || val === undefined || val === '') {
        totalCells.push(cellTotalLabel('—'))
        return
      }

      if (typeof val === 'number') {
        if (isCurrencyCol(colName)) {
          totalCells.push(cellTotalMoney(val))
        } else if (isNumericCol(colName)) {
          totalCells.push(cellTotalNumber(val))
        } else {
          totalCells.push(cellTotalLabel(String(val), 'right'))
        }
      } else {
        totalCells.push(cellTotalLabel(String(val), colIdx === 0 ? 'center' : 'left'))
      }
    })
    sheetData.push(totalCells)
  }

  const ws = XLSX.utils.aoa_to_sheet(sheetData)
  ws['!cols'] = autoFitColumns(sheetData, 14)
  ws['!merges'] = [
    { s: { r: 0, c: 0 }, e: { r: 0, c: lastColIdx } },
    { s: { r: 1, c: 0 }, e: { r: 1, c: lastColIdx } },
    { s: { r: 2, c: 0 }, e: { r: 2, c: lastColIdx } },
  ]
  ws['!rows'] = [
    { hpt: 26 }, // Banner 1
    { hpt: 22 }, // Banner 2
    { hpt: 18 }, // Metadados
    { hpt: 10 }, // Vazio
    { hpt: 24 }, // Header colunas
    ...rows.map(() => ({ hpt: 19 })),
    ...(totalsRow ? [{ hpt: 22 }] : []),
  ]

  return ws
}


// Célula de Status Colorida (Padrão Regularidade GID: Verde #45CE01, Vermelho #D60606, Laranja #FF8400, Cinza #A7A7A7)
export const cellStatusBadge = (
  val: string,
  status: 'enviado' | 'pendente' | 'justificado' | 'domingo' | 'regular' | 'parcial' | 'irregular'
) => {
  const colorMap: Record<string, { bg: string; fg: string }> = {
    enviado: { bg: '45CE01', fg: 'FFFFFF' },
    regular: { bg: '45CE01', fg: 'FFFFFF' },
    pendente: { bg: 'D60606', fg: 'FFFFFF' },
    irregular: { bg: 'D60606', fg: 'FFFFFF' },
    justificado: { bg: 'FF8400', fg: 'FFFFFF' },
    parcial: { bg: 'FF8400', fg: 'FFFFFF' },
    domingo: { bg: 'A7A7A7', fg: 'FFFFFF' },
  }
  const palette = colorMap[status] || { bg: 'F1F5F9', fg: '0F172A' }

  return {
    v: val,
    t: 's' as const,
    s: {
      font: { name: 'Calibri', sz: 9.5, bold: true, color: { rgb: palette.fg } },
      fill: { fgColor: { rgb: palette.bg } },
      alignment: { horizontal: 'center', vertical: 'center' },
      border: {
        top: { style: 'thin', color: { rgb: 'FFFFFF' } },
        bottom: { style: 'thin', color: { rgb: 'FFFFFF' } },
        left: { style: 'thin', color: { rgb: 'FFFFFF' } },
        right: { style: 'thin', color: { rgb: 'FFFFFF' } },
      },
    },
  }
}
